import { toFlatField } from '../oasis-types';
export const CardiovascularVersioned = {
    problems: { e1: { alias: 'problems', timepoint: ['soc', 'roc'] } },
};
export const Cardiovascular = toFlatField(CardiovascularVersioned);
